export default "__VITE_ASSET__WAZQu5tA__"